import React, { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import { AiOutlineClear } from 'react-icons/ai';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { FieldDropdown } from '../../../../themes/components/FieldDropdown';

export const BuscaPedidosAprov = () => {
    let history = useHistory();
    const { filtrarPedidosAprovacao, tiposPedidos } = usePedidos();
    const [numPedido, setNumPedido] = useState<string>("");
    const [codCliente, setCodCliente] = useState<string>("");
    const [tipoPedido, setTipoPedido] = useState<string>("");

    function handleBuscarPedido() {
        filtrarPedidosAprovacao(codCliente, numPedido, "2", "", tipoPedido.length > 0 ? tipoPedido.substring(0,1) : "", history);
    }

    //Buscando os pedidos na primeira vez que a tela abrir, ainda sem filtro;
    useEffect(() => {
        filtrarPedidosAprovacao(codCliente, numPedido, "2", "", tipoPedido, history);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleClearFields() {
        setTipoPedido("");
        setCodCliente("");
        setNumPedido("");
    }

    const handleChangeNumPedido = (event: React.ChangeEvent<{ value: unknown }>) => {
        setNumPedido(event.target.value as string);
    };

    const handleChangeCodigoCliente = (event: React.ChangeEvent<{ value: unknown }>) => {
        setCodCliente(event.target.value as string);
    };

    return (
        <div className="pedido-campo-busca">
            <form>
                <div className="form-row">
                    <div className="form-line-aprovacao">
                        <div className="form-group">
                            <label htmlFor="user">Cliente</label>
                            <div className="pedido-linha-campo">
                                <input type="text" className="form-control" id="cod-cliente" name="cod-cliente" onChange={handleChangeCodigoCliente} value={codCliente} placeholder="Código ou nome"/>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="user">Número do Pedido</label>
                            <div className="pedido-linha-campo">
                                <input type="text" className="form-control" id="numPedido" name="numPedido" onChange={handleChangeNumPedido} value={numPedido} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="consulta-combobox-tipo-pedido">Tipo do Pedido</label>
                            <div className="pedido-linha-campo">
                                <FieldDropdown
                                    value={tipoPedido}
                                    id="consulta-combobox-tipo-pedido"
                                    options={tiposPedidos}
                                    label={(option: string) => option}
                                    onChange={(event, newInputValue) => {
                                        setTipoPedido(newInputValue);
                                      }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-buttons">
                        <button type="button" onClick={() => handleBuscarPedido()} ><FaSearch color="#444" style={{ marginBottom: '0.3em' }} /></button>
                        <button type="button" onClick={() => handleClearFields()}><AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} /></button>
                    </div>
                </div>
            </form>
        </div>
    )
}